export const LIST_FAQ = [
  {
    key: 'box1',
    title: 'General questions - What is Hubista?',
    listQuestions: [
      {
        key: 'question1',
        question: 'What is Hubista ? ',
        answer: `Hubista is an online marketplace for physical services. Hubista is making life easier both for buyers and sellers and the ambition is to increase transparency, efficiency and make it easier for
                  both parties to take well informed decisions.`,
        active: false,
      },
      {
        key: 'question2',
        question: 'How does it work?',
        answer: `Hubista proving an online platform for services under predefined service categories. Sellers can easily create listings, set prices and be in control of their availability, whereas buyers can
                  easily filter and search for the needed service. Parties can communicate via Hubista in a secure and efficient way at the same time when the payment is processed in the background.`,
        active: false,
      },
      {
        key: 'question3',
        question: 'Who decides how / where the service is delivered?',
        answer: `Buyers are in control of the address of the service delivery.
                  The possibilities are endless, choose between home, work or an event venue, the power is in the buyers hands!`,
        active: false,
      },
      {
        key: 'question4',
        question: 'Do I need an account to use Hubista?',
        answer: `In order to access to the marketplace both buyers and sellers need to create an account. We have tried to make is as easy as possible and therefore you can log in by using existing Facebook
                  or Google accounts, alternatively you can create an account by using your existing email address.`,
        active: false,
      },
      {
        key: 'question5',
        question: 'What kind of services are available on Hubista?',
        answer: `There are five different service categories currently available on the platform:hairdresser, music, photograph & video maker, something to eat and drink and wellness.`,
        active: false,
      },
      {
        key: 'question6',
        question: 'How do sellers and buyers communicate with each other?',
        answer: `Once a buyer has found an interesting service, it is available to send enquiry to the seller to clarify some unclarities. Also communication channel is always opened as a result of executed
                  booking.`,
        active: false,
      },
      {
        key: 'question7',
        question: 'Instant booking vs. request to book - what’s the difference?',
        answer: `Hubista gives sellers two booking options that will be available for the buyers: instant booking and request to book. Request book enable buyers to send questions to seller prior to sending
                  a booking request. Once the booking request is sent the seller is always able to review the made booking and the seller will have 48 hours to approve the booking. Otherwise the booking will
                  be automatically rejected.`,
        active: false,
      },
      {
        key: 'question8',
        question: 'How does it work with guarantees? ',
        answer: `Hubista is an online platform provider and Hubista is not providing any guarantees when it comes to the quality, delivery or accuracy of the service. Hubista will aim to increase transparency
                  between sellers and buyers, why Hubista is also giving both buyers and sellers the possibility to leave a review after a successful service delivery and hereby increase the transparency so
                  that buyers get the needed information to make well informed purchase decisions.`,
        active: false,
      },
    ],
  },
  {
    key: 'box2',
    title: 'Buyers - what should I know?',
    listQuestions: [
      {
        key: 'question1',
        question: 'What are the benefits of buying services through Hubista?',
        answer: `Hubista aims to increase transparency and provide as much information as possible so that you can make well informed decisions. The ambition is to tie
          together supply and demand so that you, as a buyer, can access and book physical services that previously has been expensive and somewhat
          cumbersome`,
        active: false,
      },
      {
        key: 'question2',
        question: 'Can I get service delivered to my home?',
        answer: `You as a buyer have the power to determine where and when the service should be delivered. Decide between home, work, or any other location and the
          seller will come to you! As a first phase, the ambition is to launch the platform in predefined cities.`,
        active: false,
      },
      {
        key: 'question3',
        question: 'How do I find available services?',
        answer: `Hubista provides a vast variety of flexible filtering options that is designed to help buyers to find the best available option for their needs.`,
        active: false,
      },
      {
        key: 'question4',
        question: 'Do I need to share my home address on Hubista?',
        answer: `It’s up to you where you would like to get the service delivered. The address information is collected during the booking process. In order to provide as
          much information as needed for the seller to approve the booking request, Hubista will provide the postal number and city prior to the booking approval
          in order to safeguard buyers privacy. After the booking has been accepted by the seller, the comprehensive service delivery address will be revealed to the
          seller.`,
        active: false,
      },
      {
        key: 'question5',
        question: 'How do I pay the service?',
        answer: `The payment information is collected during the check out process and we accept all common credit and debit cards.`,
        active: false,
      },
      {
        key: 'question6',
        question: 'Is there a possibility to cancel my booking',
        answer: `The charge will be made on your card once the booking as has been confirmed by the seller.`,
        active: false,
      },
      {
        key: 'question7',
        question: 'How do I find the best seller?',
        answer: `Hubista provides vast variety of different filters that will help you the best available service provider for the given price and time.`,
        active: false,
      },
    ],
  },
  {
    key: 'box3',
    title: 'Seller - How does it work?',
    listQuestions: [
      {
        key: 'question1',
        question: 'What are the benefits of selling services through Hubista?',
        answer: `First and foremost, why wouldnt you try to get some additional bookings through Hubista? The platform is build on an idea that you as a seller dont need to have your own studio or venue, but that you can go to the
          buyer! This will help you to cut your costs and it will also lower the barrier for buyers to consume more service once it’s literally behind the front door. The aim is that shouldnt take more than 15 minutes to create a
          listing and start selling and the best thing is that you dont need to sell in order to get gigs. Buyers can browse your availability while you can be focusing on other things. The only action that is required from you is to
          review the booking request, approve the booking and deliver the service!`,
        active: false,
      },
      {
        key: 'question2',
        question: 'How does it work with the availability calendar?',
        answer: `You as a seller are in control of the availability shown on the platform. The calendar will show your availability 6 months forward, and you can easily chance the availability as you go. The ambition has been to make it
          as easy as possible and therefore we work with so called base availability that will be replicated every week going forward. Also you can add exceptions when it comes to receiving time for example for doctor visits or
          similar. Last but not least you can add additional time between bookings that will help you to move around between bookings!`,
        active: false,
      },
      {
        key: 'question3',
        question: 'Can I choose how buyers can book my services?',
        answer: `In order to provide options we have currently two available options for bookings: request to book and instant booking. As you might guess the request to book option will open a chat functionality before the actual
          booking is completed. The buyer may have questions such as “what kind of music do you plan”. After the possible unclarities have been clarified the buyer can easily send an instant booking to secure the booking.
          Through instant booking the buyer will indicate that they would like to book a specific service at a specific time. In order to make sure that you have seen and reviewed the booking, it is required that you as a seller
          approve the booking within 48 hours from the booking. Otherwise the booking will be automatically cancelled.`,
        active: false,
      },
      {
        key: 'question4',
        question: 'How information do I get before approving the booking request?',
        answer: `We aim to provide as much information as possible for you to do well informed decisions. As a seller we will provide you with the booking details: service, time and delivery details covering postal code and city. As the
          services must be delivered to the predefined address it is important that you make sure that the location suits your planning and schedule! In order to make it even easier you are able to add extra time between the
          booking in order to secure that you can move from location A to location B in time.`,
        active: false,
      },
      {
        key: 'question5',
        question: 'Who decides where the service will be delivered? ',
        answer: `As a service provider you will be able to determine the geographical area where you would like to provide your services (e.g. Stockholm or Uppsala). Buyers on the other hand will determine the exact location where
          the service delivery will take place. However, you will always be able to review the desired service delivery address in prior to accepting the booking. All booking requests must be approved by you as a seller`,
        active: false,
      },
      {
        key: 'question6',
        question: 'How and when do I get paid for the gig? What is Stripe?',
        answer: `In order to handle the payments in a secure and efficient way we have partnered up with Stripe. During the listing creation process all sellers are requested to create a Stripe account and provide the needed know
          your customer information to Stripe together with account details where the payments should be made after successful service delivery. Payment will be mad automatically through Stripe to your account right
          after service delivery.`,
        active: false,
      },
      {
        key: 'question7',
        question: 'What happens if I must cancel the booking?',
        answer: `Both seller and buyer are able to cancel the booking up till 48 hours before service delivery. However, make sure to ensure to keep buyer up to date if you for example are feeling sick or similar. Buyers are relying on
          the fact that they will be getting a service delivery from you in line with the made booking.`,
        active: false,
      },
      {
        key: 'question8',
        question: 'Do I need to pay tax on my income?',
        answer: `Make sure to check with your national tax authority that live up to the national requirements. Hubista does not provide support in tax related questions`,
        active: false,
      },
    ],
  },
  {
    key: 'box4',
    title: 'Payment service provider',
    listQuestions: [
      {
        key: 'question1',
        question: 'I received an email from Stripe. Who is Stripe? Is this email real?',
        answer: `We have parted up with Stripe to manage payments flows. Updating information about your account is important and required. These updates help
          protect against fraud and keep your account up to date in line with global Know Your Customer (KYC) regulations.`,
        active: false,
      },
      {
        key: 'question2',
        question: 'Why am I being asked for information about who owns and manages my company?',
        answer: `In certain countries, Stripe is required to collect, verify, and maintain information about a company’s beneficial owners and directors. These requirements
          come from government regulators and help promote transparency and prevent financial crimes.`,
        active: false,
      },
      {
        key: 'question3',
        question: 'What happens if I do not update my information by the deadline?',
        answer: `If you cannot update your account information by the deadline, payouts to your bank account and your ability to accept payments will be paused. We
          want to make sure that does not happen, so please let us know how we can help.`,
        active: false,
      },
      {
        key: 'question4',
        question: 'How do I update my information? ',
        answer: `Follow the link from Stripe’s email—the form will prompt you with instructions on how to update your information. It should take less than 5 minutes to
          update your information. If you need help, you can reach out directly to Stripe Support.`,
        active: false,
      },
    ],
  },
];

export const LIST_FAQ_FINLAND = [
  {
    key: 'box1',
    title: 'Yleistä - Mikä on Hubista?',
    listQuestions: [
      {
        key: 'question1',
        question: 'Mikä on Hubista? ',
        answer: `Hubista on digitaalinen markkinapaikka fyysisten palveluiden myyntiin ja ostoon. Hubista helpottaa sekä asiakkaiden, että palveluntarjoajien elämää lisäämällä tehokkuutta, läpinäkyvyyttä ja keräämällä suuren määrän eri palveluita samalle markkinapaikalle. Myynti-ilmoituksen luominen käy käden käänteessä ja palvelun ostaminen käy sitäkin nopeammin!`,
        active: false,
      },
      {
        key: 'question2',
        question: 'Miten se toimii?',
        answer: `Hubista tarjoaa markkinapaikan ennalta määritellyille palvelukategorioille, aina hiustenleikkuusta, muusikoihin ja koiranulkoiluttajiin, sekä paljon muuta! Palveluntarjoajat voivat helposti luoda myynti-ilmoituksia, hinnoitella ja hallita palveluiden varattavuutta, kun taas asiakkaat voivat helposti etsiä ja varata tarvitsemansa palvelun. Hubista mahdollistaa osapuolten välisen kommunikoinnin turvallisesti ja tehokkaasti ilman puhelinnumeroiden vaihtoa. Me hoidamme maksuliikenteen, jotta sinä voit keskittyä siihen joka on sinulle tärkeää!`,
        active: false,
      },
      {
        key: 'question3',
        question: 'Ketä tekee päätöksen miten / mihin palvelu toimitetaan?',
        answer: `Asiakas päättävät palvelun toimitusosoitteen. 
  Mahdollisuudet ovat rajattomat, valitse kodin, työpaikan tai jokin muu tapahtumapaikan välillä, valta on asiakkaan käsissä! `,
        active: false,
      },
      {
        key: 'question4',
        question: 'Onko käyttäjätilin luominen pakollista?',
        answer: `Sekä asiakkaiden, että palveluntarjoajien on luotava käyttäjätili, jonka avulla käyttäjä pääsee käsiksi markkinapaikkamme eri ominaisuuksiin. Olemme kuitenkin pyrkineet tekemään käyttäjätilin luomisesta mahdollisimman helppoa ja siksi voit kirjautua sisään olemassa olevilla Facebook- tai Google-tileillä, tai vaihtoehtoisesti voit luoda tilin käyttämällä olemassa olevaa sähköpostiosoitetta ja valitsemaasi salasanaa.`,
        active: false,
      },
      {
        key: 'question5',
        question: 'Mitä erilaisia ​​palveluita on saatavilla Hubista palvelun kautta?',
        answer: `Tarkoituksenamme on tarjota laajat mahdollisuudet sekä palveluntarjoajille, että asiakkaille. Pyrimme koko ajan lisäämään uusia palvelukategorioita, jotta juuri sinä löydät etsimäsi palvelun Hubista markkinapaikalta. Päivitetyn listan saatavilla olevista palveluista löydät etusivultamme.`,
        active: false,
      },
      {
        key: 'question6',
        question: 'Millä tavoin asiakkaat ja palveluntarjoajat voivat kommunikoida keskenään?',
        answer: `Kaikki kommunikaatio tapahtuu Hubista palvelualustan kautta. Kommunikaatio on aina yhteydessä tiettyyn myynti-ilmoitukseen ja palveluntarjoaja voi halutessaan mahdollistaa kommunikaation aloittamisen jo ennen varauksen tekoa. Muissa tapauksissa kommunikaatioyhteys avautuu varauksenteon yhteydessä.`,
        active: false,
      },
      {
        key: 'question7',
        question: 'Suoravaraus vs. varaustiedustelu - miten varausvaihtoehdot eroavat toisistaan?',
        answer: `Hubista tarjoaa palveluntarjoajille kaksi varausvaihtoehtoa: suoravaraus ja varaustiedustelu. Jälkimmäinen antaa asiakkaille mahdollisuuden lähettää kysymyksiä palveluntarjoajalle ennen varauksen lähettämistä. Suoravaraus lähettää nimensä mukaisesti varauksen suoraan palveluntarjoajalle. 
  Jokaisen varauksen yhteydessä palveluntarjoajan tulee tarkistaa ja ja hyväksyä varaus 48 tunnin kuluessa, muussa tapauksessa varaus hylätään automaattisesti. Maksusuoritus veloitetaan vasta kun palveluntarjoaja on hyväksynyt varauksen.`,
        active: false,
      },
      {
        key: 'question8',
        question: 'Onko Hubista markkinapaikan kautta tilatuilla palveluilla takuuta?',
        answer: `Hubista on markkinapaikan ylläpitäjä. Hubista ei takaa tilattujen palveluiden laatua, toimitusta tai paikkansapitävyyttä. Hubista pyrkii helpottamaan palveluntarjoajien ja asiakkaiden välistä kommunikaatiota, jonka takia Hubista antaa asiakkaille ja palveluntarjoajille mahdollisuuden jättää arvostelu onnistuneen palvelutoimituksen jälkeen. 
  Jätetyt arvostelut helpottavat osapuolia tekemään päätöksiä tulevaisuudessa ja tarkoituksena on luoda yhteisö, jossa käyttäjät luottavat toinen toisiinsa.`,
        active: false,
      },
    ],
  },
  {
    key: 'box2',
    title: 'Asiakas - Mitä minun tulisi tietää?',
    listQuestions: [
      {
        key: 'question1',
        question: 'Mitä Hubista tarjoaa?',
        answer: `Hubista tarjoaa markkinapaikan fyysisten palveluiden myyntiin ja ostoon. Pyrimme lisäämään läpinäkyvyyttä ja tarjoamaan mahdollisimman paljon tietoa jotta sinä voit tehdä hyviä ostopäätöksiä. Tavoitteena on tuoda palveluntarjoajat lähemmäs potentiaalisia asiakkaita ja tarjota mahdollisuuden vertailla ja löytää sen parhaan vaihtoehdon juuri sinun tarpeisiin!`,
        active: false,
      },
      {
        key: 'question2',
        question: 'Miten palvelun toimitus toimii, voinko palveluntarjoaja tulla kotiini? ',
        answer: `Asiakkailla on valta päättää, mihin ja milloin palvelu toimitetaan (ennalta määriteltyjen paikkakuntien sisällä). Valitse kodin, työpaikan tai jonkin muun sijainnin välillä, ja palveluntarjoaja tulee luoksesi!`,
        active: false,
      },
      {
        key: 'question3',
        question: 'Miten löydän varattavissa olevia palveluita?',
        answer: `Hubista tarjoaa laajan valikoiman joustavia suodatus-vaihtoehtoja, jotka on suunniteltu auttamaan sinua löytämään parhaan saatavilla olevan vaihtoehdon.`,
        active: false,
      },
      {
        key: 'question4',
        question: 'Tarvitseeko minun jakaa kotiosoitteeni muille käyttäjille?',
        answer: `Sinä päätät, minne palvelu toimitetaan ja osoitetiedot kerätään varausta tehdessä. Jotta palveluntarjoajalla olisi mahdollisuus tarkistaa varaus ja pitämään huolen siitä, että tämä sopii hänen aikatauluun tullaan postitoimipaikka näyttämään ennen varauksen hyväksyntää. Hubista julkaisee vain postinumeron ja paikkakunnan ennen varauksen hyväksymistä asiakkaiden yksityisyyden turvaamiseksi. Kun palveluntarjoaja on hyväksynyt varauksen tullaan palvelun toimitusosoite paljastamaan palveluntarjoajalle. Asiakkaalla on mahdollisuus tarkastella palveluntarjoajalle luovutettuja osoitetietoja viestit-osiosta.`,
        active: false,
      },
      {
        key: 'question5',
        question: 'Miten maksan löytämäni palvelun?',
        answer: `Maksutiedot kerätään varauksen yhteydessä ja hyväksymme kaikki yleisimmät luotto- ja pankkikortit.`,
        active: false,
      },
      {
        key: 'question6',
        question: 'Onko varauksen peruuttaminen mahdollista?',
        answer: `Varauksen peruuttaminen on mahdollista 48 tuntia ennen palvelun alkamisaikaa. Peruutus voidaan tehdä sekä asiakkaan, että palveluntarjoajan toimesta.`,
        active: false,
      },
      {
        key: 'question7',
        question: 'Miten löydän parhaan palvelun?',
        answer: `Hubista tarjoaa laajan valikoiman erilaisia ​​suodattimia, jotka auttavat sinua löytämään parhaan saatavilla olevan palvelu antamasi hintahaarukan sisällä.`,
        active: false,
      },
    ],
  },
  {
    key: 'box3',
    title: 'Palveluntarjoaja - miten tämä toimii?',
    listQuestions: [
      {
        key: 'question1',
        question: 'Miksi minun kannattaa aloittaa myynti Hubista palvelun kautta?',
        answer: `Meidän lähtökohtana on tehdä lisämyynnin luonnista mahdollisimman helppoa! Siksi haluammekin esittää kysymyksen: miksi ei? Miksi et yrittäisi saada lisätuloja Hubista palvelun kautta? Alusta rakentuu ajatukselle, että myynnin aloittaminen tulisi olla mahdollisimman helppoa ja, että voit panostaa siihen mikä sinua kiinnostaa. Palveluntarjoajana sinulla ei tarvitse sitoutua hintaviin tilavuokriin, vaan voit viedä palvelun suoraan asiakkaalle! 
  Autamme sinua leikkaamaan kiinteitä kustannuksia tai ainakin autamme sinua pitämään ne mahdollisimman alhaisina. Uskomme, että palveluiden ns. kotiinkuljetus tulee myös alentamaan kynnystä ostaa palveluita.
  Tavoitteenamme on, että myynti-ilmoituksen luomiseen ja myynnin aloittamiseen ei mene yli 15 minuuttia. Ostajat voivat selata palveluitasi ja varattavuutta minä kellonaikana tahansa, ja sinä voit keskittyä muihin asioihin. Sinun tulee vain pitää huolen, että hyväksyt kaikki varauspyynnöt 48 tunnin kuluessa varauksen saapumisesta.`,
        active: false,
      },
      {
        key: 'question2',
        question: 'Varattavuus - mitä se tarkoittaa?',
        answer: `Palveluntarjoajana sinä hallitset markkinapaikalla näkyvää varattavuutta. Varauskalenteri näyttää saatavilla olevan varattavuuden 6 kuukautta eteenpäin, ja voit hallita kalenteriasi helposti myynti-ilmoitus osion alta. Voit myös halutessasi lisätä aikaa varausten välille, joka auttaa sinua liikkumaan eri toimitusosoitteiden välillä ilman suurempaa stressiä!`,
        active: false,
      },
      {
        key: 'question3',
        question: 'Voinko vaikuttaa siihen miten ostajat voivat varata palveluitani?',
        answer: `Vaihtoehtojen tarjoamiseksi meillä on tällä hetkellä valittavissa kaksi eri varausvaihtoehtoa: varauspyyntö ja suoravaraus. Palveluntarjoajana sinulla on mahdollisuus valita markkinapaikalla näkyvä varausvaihtoehto tai vaikka molemmat. Kuten arvata saattaa, varauspyyntö avaa viesti-toiminnon ennen varsinaisen varauksen lähettämistä. Asiakkaalle tarjotaan tällä tavoin mahdollisuus esittää tarkentavia kysymyksiä ennen lopullisen varauksen tekoa. Suoravarauksen kautta ostaja lähettää varauspyynnön koskien tiettyä palvelua tiettynä ajankohtana. Palveluntarjoajalta vaaditaan molemmissa tapauksissa hyväksymään varaus taataksemme, että olet nähnyt ja hyväksynyt varauksen. Varaus tulee hyväksyä 48 tunnin sisällä varauksen saapumisesta, muussa tapauksessa varaus peruuntuu automaattisesti. Tulemme pitämään asiakkaan ajan tasalla sekä sähköpostitse, että Hubista viestit-osion kautta.`,
        active: false,
      },
      {
        key: 'question4',
        question: 'Minkä tiedon perusteella minun tulee hyväksyä vastaanotettu varaus?',
        answer: `Pyrimme tarjoamaan mahdollisimman paljon tietoa varauksen yhteydessä, jotta voit tehdä laskelmoituja päätöksiä. Pidämme huolen, että tulet aina saamaan palvelutiedot, ajan ja päivämäärän sekä toimitus-alueen. Ennen varauksen hyväksyntää tulet näkemään postinumeron ja postitoimipaikan, ja varauksen hyväksynnän jälkeen tulet näkemään koko toimitusosoitteen sis. katuosoitteen. Koska palvelut on toimitettava ennalta määritettyyn osoitteeseen, on tärkeää varmistaa, että sijainti sopii aikatauluusi! Lisäksi voit lisätä aikaa varausten välille varmistaaksesi, että sinulla on tarpeeksi aikaa liikkua paikasta A paikkaan B.`,
        active: false,
      },
      {
        key: 'question5',
        question: 'Kuka päättää, minne palvelu toimitetaan?',
        answer: `Palveluntarjoajana sinulla on mahdollisuus määritellä maantieteellinen alue paikkakunnittain jonka sisällä olet halukas myymään ja toimittamaan palveluitasi. Ostajat puolestaan ​​määrittävät tarkan osoitteen jonne palvelu toimitetaan. Palveluntarjoajana sinulla on kuitenkin aina mahdollisuus tarkistaa asiakkaan määrittelemä toimituspaikka (postinumero + postitoimipaikka) ennen varauksen hyväksymistä. Palveluntarjoajan on hyväksyttävä / hylättävä kaikki saapuneet varaukset, muuten varaus hylätään automaattisesti 48 tunnin jälkeen.`,
        active: false,
      },
      {
        key: 'question6',
        question: 'Miten ja milloin saan rahaa toimittamastani palvelusta? Mikä on Stripe?',
        answer: `Maksuliikenteen hallinnointi on meille hyvin tärkeää, tästä syystä teemme yhteistyötä ja luotamme Stripe-yhtiön ammattitaitoon. Jotta myynti-ilmoituksen luominen on mahdollista, tulee jokaisen palveluntarjoajan luoda Stripe-asiakastili. Onnistuneen palvelutoimituksen jälkeen maksu suoritetaan automaattisesti Stripen kautta ilmoittamallesi pankkitilille.`,
        active: false,
      },
      {
        key: 'question7',
        question: 'Mitä tapahtuu, jos minun on peruutettava varaus?',
        answer: `Sekä palveluntarjoajalla, että asiakkaalla on oikeus peruuttaa tehty varaus 48 tuntia ennen palvelun toimittamista. Varmista kuitenkin, että pidät asiakkaan aina ajan tasalla jos peruutus tulee ajankohtaiseksi. Asiakkaat luottavat siihen, että he saavat palvelutoimituksen tehdyn varauksen mukaisesti.`,
        active: false,
      },
      {
        key: 'question8',
        question: 'Tuleeko minun maksaa tekemistä tuloista veroa?',
        answer: `Varmista, että käännyt verottajan puoleen kaikissa verotukseen liittyvissä kysymyksissä. Hubista ei tarjoa tukea verotukseen liittyvissä kysymyksissä.`,
        active: false,
      },
    ],
  },
  {
    key: 'box4',
    title: 'Maksupalveluntarjoaja',
    listQuestions: [
      {
        key: 'question1',
        question: 'Kuka on Stripe, sain heiltä sähköpostia? Onko tämä sähköposti aito?',
        answer: `Stripe on yhteistyökumppanimme maksuliikenteen hallinnoinnissa. Pystyäksemme keräämään ja käsittelemään maksukorttitietoja ja suorittamaan maksusuorituksia onnistuneiden palvelutoimitusten jälkeen vaaditaan kaikilta palveluntarjoajilta Stripe-tili. Stripe-tiliä koskevien tietojen ylläpitäminen ja päivittäminen on pakollista. Nämä päivitykset pitävät tilisi ajan tasalla Know Your Customer (KYC) -säännösten mukaisesti.`,
        active: false,
      },
      {
        key: 'question2',
        question: 'Miksi Stripe kerää tietoja yrityksen omistajista ja johtajista?',
        answer: `Stripen on kerättävä, tarkistettava ja ylläpidettävä tietoja yrityksen tosiasiallisista omistajista ja johtajista. Nämä vaatimukset tulevat viranomaisilta ja auttavat edistämään läpinäkyvyyttä ja ehkäisemään talousrikoksia.`,
        active: false,
      },
      {
        key: 'question3',
        question: 'Mitä tapahtuu, jos en päivitä tietojani annetun aikarajan puitteissa?',
        answer: `Jos et päivitä tietojasi Stripe-tililläsi määräaikaan mennessä, maksut pankkitilillesi keskeytetään. Olethan yhteydessä suoraan Stripe palveluun, jos sinulla on kysyttävää Stripe-tiliäsi koskevissa kysymyksissä.`,
        active: false,
      },
      {
        key: 'question4',
        question: 'Miten voin päivittää Stripe-tiliäni?',
        answer: `Seuraa Stripe:lta saadussa sähköpostissa olevaa linkkiä – vastaa lomakkeella esitettyihin kysymyksiin ja olet askeleen lähempänä myynnin aloittamista! Tietojesi päivittämisen pitäisi kestää noin 5 minuuttia. Jos tarvitset apua tai lisätietoa, voit olla suoraan yhteydessä Stripen asiakaspalveluun.`,
        active: false,
      },
    ],
  },
];

export const LIST_FAQ_SWEDEN = [
  {
    key: 'box1',
    title: 'Generella frågor - Vad är Hubista?',
    listQuestions: [
      {
        key: 'question1',
        question: 'Vad är Hubista ? ',
        answer: `Hubista är en digital marknadsplats för fysiska tjänster. Vi vill göra livet enklare för både köpare och säljare. Vi strävar efter att öka transparensen så att köpare kan känna att de gör välinformerade beslut och vi vill ge säljare en möjlighet att i större utsträckning själva kunna lägga styra översin tid.`,
        active: false,
      },
      {
        key: 'question2',
        question: 'Hur fungerar det?',
        answer: `Hubista är en digital marknadsplats för fysiska tjänster inom vissa givna tjänstekategorier. Den som säljer tjänster skapar enkelt en annons i vilken man beskriver tjänsten samt anger pris och tillgänglighet. Den som söker efter en tjänst kan med hjälp av filtreringsfunktionen enkelt hitta annonsen som säljaren skapat. Men hjälp av plattformens bokningsfunktion kan sedan köpare smidigt boka tid och även ifall man så önskar chatta med varandra.`,
        active: false,
      },
      {
        key: 'question3',
        question: 'Vem bestämmer hur och var tjänsten ska levereras?',
        answer: `När en säljare skapar en annons så väljer säljaren själv var man vill leverera tjänsten - hos sig själv, hos köparen eller på någon anna plats. En grundtanke bakom Hubista är att ta tjänsten närmare kunden`,
        active: false,
      },
      {
        key: 'question4',
        question: 'Behöver jag skapa en profil för att använda Hubista?',
        answer: `För att sälja och köpa tjänster måste användaren skapa en profil. Om du endast är ute efter att söka och eller se vad för tjänster som finns på plattformen så går det även utan en profil. För att göra det så enkelt som möjligt att skapa en profil så kan du använda din befintliga Facebook- eller Google profil för att logga in.`,
        active: false,
      },
      {
        key: 'question5',
        question: 'Vilka typer av tjänster finns på Hubista?',
        answer: `När du skapar en annons på Hubista behöver du ange vilken servicekategori som den tillhandahållna tjänsten tillhör. Hubista har ett antal kategorier som kan variera över tid och som fastställs av Hubista. Du hittar dessa kategorier på plattformens startsida i rullistan “Välj en servicekategori”.`,
        active: false,
      },
      {
        key: 'question6',
        question: 'Hur kommunicerar köpare och säljare med varandra?',
        answer: `På plattformen finns en chattfunktion. Detta är kommunikationskanalen mellan köpare och säljare. Den kan användas för att ställa frågor om tjänsten (innan köket) samt för att eventuellt ställa praktiska frågor inför leveransen.`,
        active: false,
      },
      {
        key: 'question7',
        question: ' Direktbokning jämfört med bokningsförfrågan - vad är skillnaden?',
        answer: ` Hubista ger säljaren två olika bokningsalternativ i samband med att en annons skapas - direktbokning och/eller bokningsförfrågan. Alternativet bokningsförfrågan gör det möjligt för köparen att kontakta säljaren innan bokningen. Detta bokningsalternativ kan vara fördelaktigt att använda för en säljare som säljer tjänster som är mer omfattande och där det är svårt att på ett uttömmande sätt beskriva tjänsten i annonsen. Genom att välja funktionen bokningsförfrågan så kommer potentiell köpare att kunna chatta med säljaren innan bokningen genomförs. Funktionen instant booking fungerar så att en köpare skickar en bokning till säljaren och inväntar sedan återkoppling från säljaren vilken kan välja att acceptera bokningen eller att avstå. Vid en direktbokning har har säljaren 48 timmar på sig att godkänna bokningen. Ifall säljaren inte godkänner bokningen under den tiden så går bokningen inte igenom. 
  `,
        active: false,
      },
      {
        key: 'question8',
        question: 'Finns det garantier? ',
        answer: ` När en säljare har godkänt en bokning har ett avtal uppstått mellan säljaren och köparen av tjänsten. Det är ett bilateralt avtal mellan dessa två parter och Hubista är inte en del av det avtalet. Hubista kan därför inte garantera själva leveransen, des kvalité eller överensstämmelsen mellan annonsen och vad som de facto levererades. En viktig del av Hubista är dock att öka transparensen mellan köpare och kvaliteten i tjänsten. Detta hoppas vi kunna göra genom att låta köpare och säljare recensera varandra.`,
        active: false,
      },
    ],
  },
  {
    key: 'box2',
    title: 'Köpare - vad borde jag veta',
    listQuestions: [
      {
        key: 'question1',
        question: 'Vad är fördelen med att köpa tjänster på Hubista?',
        answer: ` Ett av våra mål är att göra vardagen enklare för köparen. Det vill vi uppnå genom att ta tjänsten närmare just dig. Vi vill också minska osäkerheten beträffande kvalité och därför har vi en funktion där köpare och säljare lämnar omdömen om varandra. Det är detta vi kallar digital mun till mun. Vi tror mycket på idén om att kunna läsa om vad andra har tyckt om en tjänst och dess utförare och därigenom kunna fatta mer välgrundade beslut.`,
        active: false,
      },
      {
        key: 'question2',
        question: 'Kan jag få en tjänst levererad hem till mig?',
        answer: ` En grundtanke bakom Hubista är att skapa mer frihet för köparen och en mindre platsbunden tjänsteleverans för säljaren. Istället för att köparen kommer till säljaren så är idén här den omvända. Men vi vill även att det ska finnas en flexibilitet i plattformen så därför ges en säljare möjlighet att själv i sin annons ange hur tjänsten levereras: hos köparen, hos säljaren eller på en annan plats. Vi hoppas självklart att just din stad ska finnas med på Hubista och gör den inte det i dagsläget så kommer förhoppningsvis efterfrågan att göra så att det snart blir verklighet!`,
        active: false,
      },
      {
        key: 'question3',
        question: 'Hur hittar jag tillgängliga tjänster?',
        answer: `Hubista handlar om fysiska tjänster så du behöver ofta börja med att ange var du vill att tjänsten ska levereras. Det fyller du enkelt i genom filtreringsfunktionen. Genom denna funktion kan du sedan enkelt lägga till fler filtreringsalternativ.`,
        active: false,
      },
      {
        key: 'question4',
        question: ' Behöver jag dela min hemadress på Hubista?',
        answer: `I en annons framgår det ifall tjänsten kan levereras hem till säljaren eller inte. Om säljaren har angett att hemleverans är möjligt så behöver du som köpare ange leveransadressen. Men för att inte dela mer information än nödvändigt, innan bokningen blivit godkänd av säljaren, så kommer endast postnumret att synas för säljaren. Detta är ett minimum för att säljaren ska kunna se om han eller hon rent logistiskt kan utföra tjänsten på den önskade platsen. När säljaren godkänt bokningen får denne/denna tillgång till den fullständiga leveransadressen.`,
        active: false,
      },
      {
        key: 'question5',
        question: 'Hur betalar jag för tjänsten?',
        answer: `Betalning sker med de vanliga betal- och kreditkorten och betalningsinformation samlas in vid utcheckningen.`,
        active: false,
      },
      {
        key: 'question6',
        question: 'Går det att avboka en redan genomförd bokning?',
        answer: `Det går att avboka en redan genomförd bokning upp till 48 timmar innan tjänsten levereras.`,
        active: false,
      },
      {
        key: 'question7',
        question: 'Hur hittar jag den bästa tjänsten?',
        answer: `Hubista tillhandahåller filter som hjälper dig att söka den tjänst som passar bäst för just dig.`,
        active: false,
      },
    ],
  },
  {
    key: 'box3',
    title: ' Säljare på Hubista - så fungerar det?',
    listQuestions: [
      {
        key: 'question1',
        question: 'Vad är fördelen med att sälja på Hubista?',
        answer: `Hubista handlar mycket om frihet och flexibilitet. Oavsett om du är i uppstartsfasen eller redan har en etablerad verksamhet så kommer Hubista att kunna hjälpa dig att öka din försäljning eller om du hellre skulle vilja det - ändra sättet du säljer på. Eftersom en av grundtankarna bakom Hubista är att ta tjänsten närmare kunden så kommer denna plattform att  ge dig som säljare en möjlighet att slippa ha en egen lokal. Hubista kommer dessutom att fungera som din hemsida och bokningsplattform. Vi vill göra det enkelt att starta upp en verksamhet och eller hitta nya sätt att öka din befintliga försäljning. Du kan fokusera på själva leveranserna medan vi ser till att driva trafik till plattformen och därigenom få fler att se just dig.`,
        active: false,
      },
      {
        key: 'question2',
        question: 'Hur fungerar kalendern?',
        answer: ` När du skapar en annons anger du samtidigt din tillgänglighet för den tjänst som annonsen handlar om. Kalendern visar tillgängligheten för 6 månader framåt men du kan allt eftersom ändra de bokningsbara tiderna. För att göra det så enkelt som möjligt för dig att fylla i din tillgänglighet så räcker det med att du fyller i en veckas säljbara tider. Kalendern kommer sedan automatiskt att duplicera denna så kallade standardvecka till varje efterföljande vecka för 6 månader framåt. Troligen kommer du inte att kunna ha exakt samma tillgänglighet varje vecka och därför finns en funktion som gör det möjligt att lägga till undantag vilket innebär att du manuellt går in och markerar vilka dagar som du inte har möjlighet att följa standardveckan. Det finns dessutom en funktionen som ger dig möjlighet att lägga in extra tid mellan varje bokning. Det kommer troligen att behövas för att du ska hinna förflytta dig mellan olika köpare. `,
        active: false,
      },
      {
        key: 'question3',
        question: 'Kan jag själv välja vilken bokningsprincip som jag ska ha?',
        answer: `Hubista ger dig som säljare två olika bokningsalternativ i samband med att en annons skapas - direktbokning och/eller bokningsförfrågan. Alternativet bokningsförfrågan gör det möjligt för köparen att kontakta säljaren innan bokningen. Detta bokningsalternativ kan vara fördelaktigt att använda för en säljare som säljer tjänster som är mer omfattande och där det är svårt att på ett uttömmande sätt beskriva tjänsten i annonsen. Genom att välja funktionen bokningsförfrågan så kommer potentiell köpare att kunna chatta med säljaren innan bokningen genomförs. Om köparen finner tjänsten intressant så använder sig köparen av direktbokningsfunktionen för att boka den önskade tjänsten. Funktionen instant booking fungerar så att en köpare skickar en bokning till säljaren och inväntar sedan återkoppling från säljaren vilken kan välja att acceptera bokningen eller att avstå. Vid en direktbokning har har säljaren 48 timmar på sig att godkänna bokningen. Ifall säljaren inte godkänner bokningen under den tiden så går bokningen inte igenom.`,
        active: false,
      },
      {
        key: 'question4',
        question:
          'Vilken information har jag tillgång till innan jag godkänner en bokningsförfrågan?',
        answer: `Innan du godkänner en bokningsförfrågan kommer du att kunna se staden och postnumret för platsen där tjänsten ska levereras. Avsikten med att presentera denna information är att du som säljare ska kunna avgöra ifall du har möjlighet att transportera dig till platsen. När du väl har godkänt bokningsförfrågan kommer den exakta adressen att bli synlig.`,
        active: false,
      },
      {
        key: 'question5',
        question: 'Vem bestämmer var tjänsten ska levereras? ',
        answer: `Du som säljare bestämmer var din tjänst ska vara tillgänglig (t.ex. Stockholm eller Göteborg). Utgångspunkten är att den exakta platsen för leveransen ska bestäms av köparen (troligen köparens hemadress). Om du som säljare vill leverera tjänsten i en egen lokal så anger du det i fritexten i annonsen.Som säljare kommer du alltid att möjlighet att se stad och postnummer innan du godkänner en bokningsförfrågan. Oavsett vilken bokningsprincip du angett så behöver en bokning alltid godkännas av dig som säljare för att blir giltig.`,
        active: false,
      },
      {
        key: 'question6',
        question: 'Hur och när får jag betalt för en utförd tjänst? Vad är Stripe?',
        answer: `För att kunna hantera betalningar på ett säkert och effektivt sätt använder sig Hubista av en betalningslösning som tillhandahålls av företaget Stripe. När du som säljare skapar en annons på Hubista behöver du även skapa ett Stripe- konto. Som säljare kommer du att få din betalning till ditt konto via Stripe efter fullföljd leverans av tjänsten.`,
        active: false,
      },
      {
        key: 'question7',
        question: 'Kan jag ställa in en redan bokad tjänst?',
        answer: `Både köpare och säljare kan avboka en redan bokad tjänst upp till 48 timmar före tjänsten ska levereras därefter försvinner den möjligheten. För en köpare som tvingas ställa in en planerad leverans efter att avbokningsmöjligheten försvunnit innebär det att hela beloppet kommer att betalas till säljaren. I den händelse en säljare skulle tvingas ställa in efter att avbokningsmöjligheten försvunnit ber vi dig ha i åtanke den besvärliga sits som din köpare kan tänkas hamna i.`,
        active: false,
      },
      {
        key: 'question8',
        question: 'Behöver jag betala skatt på min inkomst?',
        answer: `Olika individers skattesituation varierar och därför behöver varje användare av plattformen kolla med Skatteverket vad som gäller för just dig.`,
        active: false,
      },
    ],
  },
  {
    key: 'box4',
    title: 'Betaltjänstleverantör',
    listQuestions: [
      {
        key: 'question1',
        question: 'Jag har fått ett mail från Stripe. Vad är Stripe och är detta ett korrekt mail?',
        answer: ` Stripe är den betaltjänstleverantör som vi använder oss av. Att hålla ditt Stripe-konto uppdaterat är viktigt för att du ska kunna erhålla ersättning för den tjänst som du levererat. Stripe kommer dessutom att kräva uppdateringar beträffande så kallade Känn-din-kund relaterade frågor.`,
        active: false,
      },
      {
        key: 'question2',
        question:
          'Varför ombeds jag besvara frågor om vem som äger och styr mitt företag, eller min enskilda firma?',
        answer: `I vissa länder åligger det Stripe att samla in, verifiera och spara information om nyckelpersoner i företag. Dessa krav ställs av lagstiftarens och de finns där för att minska risken för ekonomisk brottslighet.`,
        active: false,
      },
      {
        key: 'question3',
        question: 'Vad händer om jag inte uppdaterar informationen som Stripe efterfrågar i tid?',
        answer: `Ifall du inte uppdaterar din kontoinformation i enlighet med de villkor som Stripe ställer upp så kommer utbetalningar till ditt bankkonto att pausas.`,
        active: false,
      },
      {
        key: 'question4',
        question: 'Hur uppdaterar jag informationen?',
        answer: `Följ länken som finns i mailet från Stripe. Här finner du information om hur du uppdaterar informationen. Det tar maximalt några minuter. Om du behöver hjälp, vänligen vänd dig till Stripe för hjälp.`,
        active: false,
      },
    ],
  },
];
